var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiScanicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 34.6467,
    r: 34.6467,
    fill: "#5AC994"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9745 24.3037V27.4735C30.9745 28.0571 30.4302 28.5301 29.7589 28.5301H26.1123C25.4409 28.5301 24.8967 28.0571 24.8967 27.4735V24.3037C24.8967 23.7201 25.4409 23.2471 26.1123 23.2471H29.7589C30.4302 23.2471 30.9745 23.7201 30.9745 24.3037Z",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8967 33.8145H30.9745",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1292 33.8145V39.0975",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0544 44.3799H43.1322",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0544 33.8411L37.0801 33.8145",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.207 33.8411L49.2326 33.8145",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0544 39.1234L37.0801 39.0967",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.207 39.1234L49.2326 39.0967",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.207 44.4066L49.2326 44.3799",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0544 28.558L37.0801 28.5312",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0544 23.2738L37.0801 23.2471",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9745 40.1533V43.3231C30.9745 43.9067 30.4302 44.3797 29.7589 44.3797H26.1123C25.4409 44.3797 24.8967 43.9067 24.8967 43.3231V40.1533C24.8967 39.5697 25.4409 39.0967 26.1123 39.0967H29.7589C30.4302 39.0967 30.9745 39.5697 30.9745 40.1533Z",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2069 24.3037V27.4735C49.2069 28.0571 48.6628 28.5301 47.9914 28.5301H44.3447C43.6733 28.5301 43.1292 28.0571 43.1292 27.4735V24.3037C43.1292 23.7201 43.6733 23.2471 44.3447 23.2471H47.9914C48.6628 23.2471 49.2069 23.7201 49.2069 24.3037Z",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.207 17.9648H55.2847V23.2479",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.207 49.6629H55.2847V44.3799",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.896 17.9648H18.8183V23.2479",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.896 49.6629H18.8182V44.3799",
    stroke: "white",
    strokeWidth: 3.38738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiScanicon);
export default __webpack_public_path__ + "static/media/UI_Scanicon.3ebd5cfc1619ecbe69ebaaa6b8bec4c1.svg";
export { ForwardRef as ReactComponent };